"use client";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

export default function Underline({ url, bgColor }) {
  const pathname = usePathname();
  const [isSamePath, setIsSamePath] = useState(false);

  useEffect(() => {
    if (pathname === url) {
      setIsSamePath(true);
    } else {
      setIsSamePath(false);
    }
  }, [pathname, url]);

  if (!isSamePath) {
    return null;
  }

  return (
    <span
      style={{
        width: "100%",
        display: "block",
        backgroundColor: bgColor,
        height: "2px",
      }}></span>
  );
}
